<div class="motivo-page ds-page" (click)="fecharDropdown()">
  <main class="ds-page-content">

    <!-- ── HEADER ── -->
    <header class="ds-page-header">
      <div class="ds-page-header-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>
        </svg>
      </div>
      <div class="ds-page-header-copy">
        <h1 class="ds-page-title">Motivos de Cancelamento</h1>
        <p class="ds-page-subtitle">Gerencie os motivos disponíveis para cancelamento de pedidos</p>
      </div>
      <div class="ds-page-actions">
        <button type="button" class="bt-novo" (click)="abrirNovo()">Novo Motivo</button>
      </div>
    </header>

    <!-- ── ALERTAS ── -->
    <div *ngIf="erro"    class="ds-alert ds-alert--danger">{{ erro }}</div>
    <div *ngIf="sucesso" class="ds-alert ds-alert--success">{{ sucesso }}</div>

    <!-- ── TABELA ── -->
    <section class="ds-card">
      <div *ngIf="carregando" class="ds-loading-state">
        <app-loading-indicator></app-loading-indicator>
        <span>Carregando...</span>
      </div>

      <div *ngIf="!carregando && motivos.length === 0 && !erro" class="ds-empty-state">
        Nenhum motivo cadastrado.
      </div>

      <div class="ds-table-container" *ngIf="!carregando && motivos.length > 0" (scroll)="fecharDropdown()">
        <table class="ds-table ds-table--sticky-header">
          <thead>
            <tr>
              <th class="col-cod">Código</th>
              <th>Motivo</th>
              <th class="col-mod">Módulo</th>
              <th class="ds-text-center">Ativo</th>
              <th class="col-data">Criação</th>
              <th class="col-usuario">Usuário</th>
              <th class="ds-table-cell--actions">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let m of motivos">
              <td class="ds-text-muted">{{ m.codigo }}</td>
              <td>{{ m.motivo }}</td>
              <td class="ds-text-muted">{{ m.modulo || '—' }}</td>
              <td class="ds-text-center">
                <span class="ds-badge" [ngClass]="ativoClass(m.ativo)">{{ labelAtivo(m.ativo) }}</span>
              </td>
              <td class="ds-text-muted ds-nowrap">{{ m.dataCriacao || '—' }}</td>
              <td class="ds-text-muted ds-nowrap">
                <span *ngIf="m.codusu">{{ m.codusu }} — {{ m.nomeUsuario || '?' }}</span>
                <span *ngIf="!m.codusu">—</span>
              </td>
              <td class="ds-table-cell--actions" (click)="$event.stopPropagation()">
                <div class="ds-dropdown">
                  <button class="btn-dots"
                    [class.btn-dots-ativo]="dropdownAberto === m.codigo"
                    [disabled]="alterando === m.codigo"
                    (click)="toggleDropdown($event, m.codigo)"
                    title="Ações">
                    <span *ngIf="alterando !== m.codigo">⋮</span>
                    <app-loading-indicator *ngIf="alterando === m.codigo" size="inline"></app-loading-indicator>
                  </button>
                  <div class="ds-dropdown-menu ds-dropdown-menu--flutuante" *ngIf="dropdownAberto === m.codigo"
                    [style.position]="'fixed'" [style.top.px]="dropdownPos?.top" [style.right.px]="dropdownPos?.right">
                    <button class="ds-dropdown-item" (click)="abrirEditar(m)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                      </svg>
                      Editar
                    </button>
                    <div class="motivo-dropdown-divider" *ngIf="proximoAtivo(m)"></div>
                    <button class="ds-dropdown-item"
                      *ngIf="proximoAtivo(m)"
                      (click)="alterarAtivo(m, proximoAtivo(m))">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M18.36 6.64A9 9 0 1 1 5.64 17.36"/>
                        <polyline points="23 12 20 9 17 12"/>
                      </svg>
                      Mudar para: {{ proximoAtivo(m) }}
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="motivo-rodape" *ngIf="!carregando && motivos.length > 0">
        {{ motivos.length }} motivo{{ motivos.length !== 1 ? 's' : '' }} cadastrado{{ motivos.length !== 1 ? 's' : '' }}
      </div>
    </section>

  </main>
</div>

<!-- ── MODAL FORMULÁRIO ── -->
<div class="ds-modal-overlay" *ngIf="modalAberto" (click)="fecharModal()">
  <div class="ds-modal ds-modal--sm" (click)="$event.stopPropagation()">

    <div class="ds-modal-header">
      <h2 class="ds-modal-title">{{ modoEdicao ? 'Editar Motivo' : 'Novo Motivo' }}</h2>
      <button type="button" class="ds-modal-close" (click)="fecharModal()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="ds-modal-body">
      <div *ngIf="erroForm" class="ds-alert ds-alert--danger ds-mb-3">{{ erroForm }}</div>

      <div class="ds-form">
        <div class="ds-field">
          <label class="ds-label ds-label-obrigatorio">Motivo</label>
          <input type="text" class="ds-input" [(ngModel)]="form.motivo"
            placeholder="Descreva o motivo de cancelamento" maxlength="100">
        </div>

        <div class="ds-form-grid">
          <div class="ds-field ds-col-6">
            <label class="ds-label ds-label-obrigatorio">Ativo</label>
            <select class="ds-select" [(ngModel)]="form.ativo">
              <option value="">Selecione...</option>
              <option *ngFor="let op of opcoesAtivo" [value]="op">{{ op }}</option>
            </select>
          </div>

          <div class="ds-field ds-col-6">
            <label class="ds-label ds-label-obrigatorio">Módulo</label>
            <select class="ds-select" [(ngModel)]="form.modulo">
              <option value="">Selecione...</option>
              <option *ngFor="let op of opcoesModulo" [value]="op">{{ op }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="ds-modal-footer">
      <button type="button" class="bt-cancelar" (click)="fecharModal()">Cancelar</button>
      <button type="button" class="bt-salvar" [class.bt-carregando]="salvando" (click)="salvar()" [disabled]="salvando"><app-loading-indicator *ngIf="salvando" size="inline"></app-loading-indicator>
        {{ salvando ? 'Salvando...' : (modoEdicao ? 'Salvar alterações' : 'Cadastrar') }}
      </button>
    </div>
  </div>
</div>
